// extracted by mini-css-extract-plugin
module.exports = {"image":"src-components-ImageViewer-index-module__image--1DvzP"};